const VariationTypeConstants = {
    VARIATION: 0,
    RISK: 1
}

export default VariationTypeConstants